import { STORE_FOOD_COURT_SETTINGS } from "../actions";

export default function storeFoodCourtSettings(payload) {
    return {
      type: STORE_FOOD_COURT_SETTINGS,
      payload
    }
  }


// WEBPACK FOOTER //
// ./src/store/actionCreators/foodCourtSettings.js